import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ListOptions from './ListOptions';
import {
  optimizeSearch,
  getOptions,
  toggleUrlVal,
} from '../../Actions/FindMyPart.action';
import { translate } from '../../Services/translation';

const FindMyPartOptionsGeneral = ({
  activeSegment,
  isInBlock,
  initBrandValue,
  initModelValue,
  initYearValue,
  preSetSegment,
  wipeSearchResults,
}) => {
  const dispatch = useDispatch();
  const brandsRef = useRef();
  const modelsRef = useRef();
  const yearsRef = useRef();
  const submitRef = useRef();
  const [selectedBrand, setSelectedBrand] = useState({});
  const [selectedModel, setSelectedModel] = useState({});
  const [selectedYear, setSelectedYear] = useState({});
  const [doAutoSearch, setDoAutoSearch] = useState(false);
  const [customerBrandChanged, setCustomerBrandChanged] = useState(false);
  const [lastChangedOptionType, setLastChangedOptionType] = useState();
  const optionsGeneral = useSelector(
    (state) => state.findMyPart.options?.optionsGeneral
  );
  const getSelectedOptionsObject = () => {
    const options = {
      segment: activeSegment,
      lastChangedOptionType:
        isInBlock && selectedModel ? 'model' : lastChangedOptionType,
      optionsGeneral: {
        brand: selectedBrand,
        model: selectedModel,
        year: selectedYear,
      },
      optionsPsg: null,
    };
    return options;
  };

  const optimize = () => {
    if (
      !selectedBrand?.value &&
      !selectedModel?.value &&
      !selectedYear?.value
    ) {
      return;
    }
    const options = getSelectedOptionsObject();
    dispatch(optimizeSearch(options));
  };
  useEffect(() => {
    if (initBrandValue.value) {
      setSelectedBrand(initBrandValue);
    }
  }, [initBrandValue]);
  useEffect(() => {
    if (initModelValue.value) {
      setSelectedModel(initModelValue);
    }
  }, [initModelValue]);

  useEffect(() => {
    if (initYearValue.value) {
      setSelectedYear(initYearValue);
    }
  }, [initYearValue]);

  useEffect(() => {
    if (selectedBrand) {
      if (customerBrandChanged) {
        wipeSearchResults();
      }
    }
  }, [selectedBrand]);

  useEffect(() => {
    if (selectedBrand?.value || selectedModel?.value || selectedYear?.value) {
      setDoAutoSearch(true);
    }
  }, [selectedBrand, selectedModel, selectedYear]);

  useEffect(() => {
    console.log('initBrandValue', initBrandValue);
    if (isInBlock) {
      setSelectedBrand(initBrandValue);
      setSelectedModel(initModelValue);
      setSelectedYear(initYearValue);
    } else {
      setSelectedBrand(initBrandValue || {});
      setSelectedModel(initModelValue || {});
      setSelectedYear(initYearValue || {});
    }
    setLastChangedOptionType('');
  }, [activeSegment]);

  useEffect(() => {
    if (lastChangedOptionType) {
      const options = getSelectedOptionsObject();
      dispatch(getOptions(options));
    }
  }, [lastChangedOptionType, selectedBrand, selectedModel]);

  //useEffect(() => {
  //  if (optionsGeneral && isInBlock) {
  //  }
  //}, [optionsGeneral]);
  //useEffect(() => {
  //  dispatch(toggleUrlVal('year', selectedYear.value));
  //}, [selectedYear]);

  useEffect(() => {
    if (
      doAutoSearch &&
      selectedBrand?.value &&
      selectedModel?.value &&
      selectedYear?.value
    ) {
      optimize();
      setDoAutoSearch(false);
    }
  }, [doAutoSearch]);

  return (
    <Fragment>
      {optionsGeneral && (
        <div className="row find-my-part__options-container">
          {optionsGeneral.brands && (
            <div className="find-my-part__option small-12 medium-4 large-3 columns">
              <ListOptions
                id="fmpBrand"
                title={translate('findmypart.brand')}
                selectRef={brandsRef}
                selectedOption={selectedBrand}
                initVal={selectedBrand}
                list={optionsGeneral.brands}
                setSelectedOption={(val) => {
                  setSelectedBrand(val);
                  setCustomerBrandChanged(true);
                  setLastChangedOptionType('brand');
                }}
                defaultText={translate('findmypart.selectbrand')}
              />
            </div>
          )}
          {optionsGeneral.models && (
            <div className="find-my-part__option small-12 medium-4 large-3 columns">
              <ListOptions
                id="fmpModels"
                title={translate('findmypart.model')}
                selectRef={modelsRef}
                selectedOption={selectedModel}
                initVal={selectedModel}
                list={optionsGeneral.models}
                setSelectedOption={(val) => {
                  setSelectedModel(val);
                  setLastChangedOptionType('model');
                }}
                defaultText={translate('findmypart.selectmodel')}
              />
            </div>
          )}
          {optionsGeneral.years && (
            <div
              className="find-my-part__option small-12 medium-4 large-3 columns"
              ref={yearsRef}
            >
              <ListOptions
                id="fmpYear"
                title={translate('findmypart.year')}
                selectRef={yearsRef}
                selectedOption={selectedYear}
                initVal={selectedYear}
                list={optionsGeneral.years}
                setSelectedOption={(val) => setSelectedYear(val)}
                defaultText={translate('findmypart.selectyear')}
              />
            </div>
          )}
          <div
            className="find-my-part__button-container small-12 large-3 columns"
            ref={submitRef}
          >
            <label htmlFor="fmpSubmit">&nbsp;</label>
            <button
              className="small-only-expanded"
              disabled={
                !(selectedYear?.value && selectedYear?.value.length > 0)
              }
              id="fmpSubmit"
              onClick={() => optimize()}
            >
              {translate('findmypart.searchpart')}
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default FindMyPartOptionsGeneral;
